import * as style from "./Button.module.css";
export const sizeValues = ["large", "medium", "small"];
export const paddingValues = ["default", "small", "medium", "large", "none"];
export const tintDarkColorValues = ["dark", "tint-dark", "tintDark", "none"];
export const tintLightColorValues = ["light", "tint-light", "tintLight"];
export const redColorValues = ["red", "red-button", "redButton"];
export const fgColorValues = ["fg", "foreground"];
export const bgColorValues = ["bg", "background"];
export const accentPrimaryColorValues = ["accent-a", "accentA", "accent-primary", "accentPrimary", "primary"];
export const accentSecondaryColorValues = ["accent-b", "accentB", "accent-secondary", "accentSecondary", "secondary"];
export const accentTertiaryColorValues = ["accent-c", "accentC", "accent-tertiary", "accentTertiary", "tertiary"];
export const colorValues = [...tintDarkColorValues, ...tintLightColorValues, ...redColorValues, ...fgColorValues, ...bgColorValues, ...accentPrimaryColorValues, ...accentSecondaryColorValues, ...accentTertiaryColorValues];
export function getClassNameForSize(size) {
  switch (size) {
    case "large":
      return style.large;
    case "medium":
      return style.medium;
    case "small":
      return style.small;
  }
}
export function getClassNameForPadding(padding, size) {
  switch (padding) {
    case "large":
      return style.largePadding;
    case "medium":
      return style.mediumPadding;
    case "small":
      return style.smallPadding;
    case "none":
      return style.noPadding;
    default:
      switch (size) {
        case "large":
          return style.largePadding;
        case "medium":
          return style.mediumPadding;
        case "small":
          return style.smallPadding;
      }
  }
}
export function getClassNameForColor(color) {
  switch (true) {
    case tintDarkColorValues.includes(color):
      return style.dark;
    case tintLightColorValues.includes(color):
      return style.light;
    case redColorValues.includes(color):
      return style.red;
    case bgColorValues.includes(color):
      return style.bg;
    case fgColorValues.includes(color):
      return style.fg;
    case accentPrimaryColorValues.includes(color):
      return style.accentPrimary;
    case accentSecondaryColorValues.includes(color):
      return style.accentSecondary;
    case accentTertiaryColorValues.includes(color):
      return style.accentTertiary;
    default:
      return style.accentPrimary;
  }
}